function get(page = 1, search = '') {
    const url = `v1/medicines?page=${page}${search ? `&search=${search}` : ''}`
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

function add(params) {
    return new Promise((resolve, reject) => {
        axios
            .post('v1/medicines', params)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

function update(params) {
    return new Promise((resolve, reject) => {
        axios
            .put('v1/medicines', params)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

function remove(id) {
    return new Promise((resolve, reject) => {
        axios
            .delete('v1/medicines', {data: {id: id}})
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

function show(id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`v1/medicines/show?id=${id}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

const Service = {
    get,
    add,
    update,
    remove,
    show
}

let axios = null

export default $axios => {
    axios = $axios
    return Service
}


